import {
  CalculatorAdditionalPaymentStep1FormFields,
  CalculatorAdditionalPaymentStep2FormFields
} from '../types';
import { IntlShape } from 'react-intl/src/types';
import {
  useAdditionalPaymentStep1FormFields,
  useAdditionalPaymentStep2FormFields
} from '../config';

const utilsAdditionalPaymentGetDefaultValuesStep1 = (
  intl: IntlShape
): CalculatorAdditionalPaymentStep1FormFields => {
  const calculatorBuyerCostsStep1FormFields = useAdditionalPaymentStep1FormFields(intl);
  return {
    mortgageType: calculatorBuyerCostsStep1FormFields.mortgageType.defaultValue,
    remainingTerm: calculatorBuyerCostsStep1FormFields.remainingTerm.defaultValue,
    mortgageAmount: calculatorBuyerCostsStep1FormFields.mortgageAmount.defaultValue,
    mortgageInterestRate: calculatorBuyerCostsStep1FormFields.mortgageInterestRate.defaultValue,
    mortgageAmount2: calculatorBuyerCostsStep1FormFields.mortgageAmount2.defaultValue,
    mortgageInterestRate2: calculatorBuyerCostsStep1FormFields.mortgageInterestRate2.defaultValue
  };
};

const utilsAdditionalPaymentGetDefaultValuesStep2 = (
  intl: IntlShape
): CalculatorAdditionalPaymentStep2FormFields => {
  const calculatorBuyerCostsStep2FormFields = useAdditionalPaymentStep2FormFields(intl);
  return {
    additionalPayment: calculatorBuyerCostsStep2FormFields.additionalPayment.defaultValue,
    paymentType: calculatorBuyerCostsStep2FormFields.paymentType.defaultValue
  };
};

const utilsAdditionalPaymentGetTranslationFormOptions = (
  intl: IntlShape,
  key: 'mortgageType' | 'paymentType',
  value: string
): string => {
  const calculatorBuyerCostsFormFields = {
    ...useAdditionalPaymentStep1FormFields(intl),
    ...useAdditionalPaymentStep2FormFields(intl)
  };

  const translatedLabel = calculatorBuyerCostsFormFields[key].options?.find(
    (option) => option.value === value
  );

  return translatedLabel ? translatedLabel.label : '';
};

export {
  utilsAdditionalPaymentGetDefaultValuesStep1,
  utilsAdditionalPaymentGetDefaultValuesStep2,
  utilsAdditionalPaymentGetTranslationFormOptions
};
